<div class="rg-page-header">
    <div>
        <h3 class="fw-bold mb-1">Organizations</h3>
        <p class="text-muted mb-0">
            Manage customer organizations connected to RiskGuard Licensing.
        </p>
    </div>

    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createOrganizationModal">
        <i class="bi bi-plus-lg me-1"></i>
        New Organization
    </button>
</div>

<div class="container-fluid p-4">
    <div class="card border-0 shadow-sm rg-card">
        <div class="card-body">
            <div class="row g-2 align-items-center mb-3">
                <div class="col-12 col-md-5">
                    <input type="text" class="form-control" placeholder="Search organization, email or phone..."
                        [(ngModel)]="search" (keyup.enter)="searchOrganizations()">
                </div>

                <div class="col-12 col-md-auto">
                    <button class="btn btn-outline-primary" (click)="searchOrganizations()">
                        <i class="bi bi-search me-1"></i>
                        Search
                    </button>
                </div>

                <div class="col-12 col-md-auto">
                    <button class="btn btn-outline-secondary" (click)="clearSearch()">
                        Clear
                    </button>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table align-middle mb-0">
                    <thead>
                        <tr>
                            <th>Organization</th>
                            <th>Contact</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th class="text-end">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngIf="!loading && organizations.length === 0">
                            <td colspan="5" class="text-center py-4 text-muted">
                                No record found.
                            </td>
                        </tr>
                        <tr *ngFor="let org of organizations">
                            <td>
                                <div class="fw-semibold">{{ org.name }}</div>
                                <small class="text-muted">{{ org.id }}</small>
                            </td>

                            <td>
                                <div>{{ org.contactEmail || '—' }}</div>
                                <small class="text-muted">{{ org.contactPhone || 'No phone' }}</small>
                            </td>

                            <td>
                                <span class="badge" [ngClass]="getStatusClass(org.status)">
                                    {{ getStatusLabel(org.status) }}
                                </span>
                            </td>

                            <td>
                                {{ org.createdAt | date:'mediumDate' }}
                            </td>

                            <td class="text-end">
                                <button class="btn btn-sm btn-outline-primary me-1"
                                    [routerLink]="['/organizations', org.id]">
                                    View
                                </button>

                                <button class="btn btn-sm btn-outline-secondary me-1" (click)="openEditModal(org)">
                                    Edit
                                </button>

                                <div class="btn-group">
                                    <button class="btn btn-sm btn-outline-dark dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                        More
                                    </button>

                                    <ul class="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <button class="dropdown-item" (click)="changeStatus(org, 'activate')">
                                                Activate
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item" (click)="changeStatus(org, 'suspend')">
                                                Suspend
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item text-danger"
                                                (click)="changeStatus(org, 'disable')">
                                                Disable
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
                <small class="text-muted">
                    Page {{ meta.page }} of {{ meta.totalPages || 1 }}
                    — {{ meta.totalItems }} item(s)
                </small>

                <div class="btn-group">
                    <button class="btn btn-outline-secondary btn-sm" [disabled]="page <= 1 || loading"
                        (click)="previousPage()">
                        Previous
                    </button>

                    <button class="btn btn-outline-secondary btn-sm" [disabled]="page >= meta.totalPages || loading"
                        (click)="nextPage()">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="createOrganizationModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rg-modal">
            <div class="modal-header">
                <h5 class="modal-title fw-bold">Create Organization</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form (ngSubmit)="createOrganization()">
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Organization Name</label>
                        <input type="text" class="form-control" name="name" placeholder="ABC Bank"
                            [(ngModel)]="createModel.name">
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Contact Email</label>
                        <input type="email" class="form-control" name="contactEmail" placeholder="admin@abcbank.com"
                            [(ngModel)]="createModel.contactEmail">
                    </div>

                    <div>
                        <label class="form-label">Contact Phone</label>
                        <input type="text" class="form-control" name="contactPhone" placeholder="+2348012345678"
                            [(ngModel)]="createModel.contactPhone">
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="creating">
                        <span *ngIf="!creating">Create Organization</span>
                        <span *ngIf="creating">Creating...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="editOrganizationModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rg-modal">
            <div class="modal-header">
                <h5 class="modal-title fw-bold">Edit Organization</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form (ngSubmit)="updateOrganization()">
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Organization Name</label>
                        <input type="text" class="form-control" name="editName" [(ngModel)]="editModel.name">
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Contact Email</label>
                        <input type="email" class="form-control" name="editContactEmail"
                            [(ngModel)]="editModel.contactEmail">
                    </div>

                    <div>
                        <label class="form-label">Contact Phone</label>
                        <input type="text" class="form-control" name="editContactPhone"
                            [(ngModel)]="editModel.contactPhone">
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="updating">
                        <span *ngIf="!updating">Save Changes</span>
                        <span *ngIf="updating">Saving...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
